var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeaveApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "sidemenuFillIcon",
    width: 22,
    height: 23,
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 13C6.2 13 3 14.7 3 18v1c0 .55.45 1 1 1s1-.45 1-1v-1c0-1.8 2.4-3 4-3s4 1.2 4 3v1c0 .55.45 1 1 1s1-.45 1-1v-1c0-3.3-3.2-5-6-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 4C6.8 4 5 5.8 5 8s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.3 11l1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L19.7 12l1.3 1.3c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3s-.5-.1-.7-.3L18.3 13l-1.3 1.3c-.2.2-.5.3-.7.3s-.5-.1-.7-.3c-.4-.4-.4-1 0-1.4l1.3-1.3-1.3-1.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L18.3 11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeaveApplication);
export default __webpack_public_path__ + "static/media/IconLeaveApplication.d5e2f4ca286fc613ea6478dfd2ca1b03.svg";
export { ForwardRef as ReactComponent };